import _ from 'lodash';
import moment from 'moment';
import Promise from 'bluebird';
import api from '../api';
import AppConfig from '../config';
// import React from 'react';
// import api from '../api';




class PublishHelper {

  async createRecentlyPublishedSchedulesData(targetDate = null, previewMode = false) {

    let currentDate = moment();
    if (!targetDate) { targetDate = currentDate; }
    let minDate = moment(targetDate).subtract(2, 'weeks');
    let maxDate = moment(targetDate).add(3, 'months');

    let minDateStr = minDate.format('YYYY-MM-DD');
    let maxDateStr = maxDate.format('YYYY-MM-DD');

    let qTheaters = {
      l: 1000,
      sf: 'sort_index',
      so: 'asc',
    };
    let qSchedules = {
      l: 1000,
      f: 'daterange_end>>' + minDateStr + ',daterange_start<<' + maxDateStr,
      sf: 'daterange_start',
      so: 'desc',
    };
    let qComingSoon = {
      l: 1000,
      f: 'date>>' + minDateStr + ',date<<' + maxDateStr,
      sf: 'date,sort_index',
      so: 'desc,asc',
    };
    let qNews = {
      l: 1000,
      f: 'archived:$null',
      sf: 'sort_index,created',
      so: 'asc,desc',
    };

    let [resTheaters, resSchedules, resComingSoonInfos, resNewsInfos] = await Promise.all([
      api.theaters.find(qTheaters),
      api.schedules.find(qSchedules),
      api.comingSoon.find(qComingSoon),
      api.news.find(qNews),
    ]);

    let theaters = _.get(resTheaters, 'data') || [];
    let schedules = _.get(resSchedules, 'data') || [];
    let comingSoonInfos = _.get(resComingSoonInfos, 'data') || [];
    let newsInfos = _.get(resNewsInfos, 'data') || [];

    if (!previewMode) {
      schedules = _.filter(schedules, v => (v.status === 'published'));
    }

    let movieIds = _.chain([])
      .concat(this.getMovieIdsFromSchedules(schedules))
      .concat(_.map(comingSoonInfos, 'movie_id'))
      .map(_.parseInt)
      .filter(v => (_.isFinite(v) && v > 0))
      .uniq()
      .compact()
      .sort()
      .value();

    let qMovies = {
      l: 1000,
      f: 'id:' + _.join(movieIds, '^'),
      sf: 'id',
      so: 'asc'
    };

    let resMovies = await api.movies.find(qMovies);
    let movies = _.get(resMovies, 'data') || [];

    let schedulesShowtimes = _.chain(schedules)
      .map(this._toPublishedDataHelper.bind(this))
      .map('showtimes')
      .flatten()
      .value();

    let newsMessageItems = _.chain(newsInfos)
      .map('message')
      .compact()
      .uniq()
      .value();

    schedules = this.patch2DMovieShowtimes(schedules, theaters, movies);

    let publishedShowtimes = new api.models.PublishedShowtimesModel();
    publishedShowtimes.publishInfo = { targetDate, published: currentDate };
    publishedShowtimes.officeInfo = AppConfig.office;
    publishedShowtimes.theaterInfos = this._toPublishedData(theaters);
    publishedShowtimes.showtimes = this._toPublishedData(schedulesShowtimes);
    publishedShowtimes.comingSoonInfos = this._toPublishedData(comingSoonInfos);
    publishedShowtimes.newsItems = this._toPublishedData(newsMessageItems);
    publishedShowtimes.movieInfos = this._toPublishedData(movies);
    if (AppConfig.dbgMode) {
      publishedShowtimes.dbgInfo = { targetDate, minDate, maxDate, movieIds };
    }

    return publishedShowtimes;
  }

  _toPublishedData(items) {
    if (_.isArray(items)) {
      return _.map(items, this._toPublishedDataHelper.bind(this));
    }
    return this._toPublishedDataHelper(items);
  }

  _toPublishedDataHelper(item) {
    if (_.isFunction(item && item.toPublishedData)) {
      item = item.toPublishedData();
    }
    return item;
  }

  getMovieIdsFromSchedules(schedules) {
    return _.chain(schedules)
      .map('showtimes')
      .flatten()
      .map('movieId')
      .value();
  }

  patch2DMovieShowtimes(schedules, theaters, movies) {
    // scan through all showtimes and force them to 2D if the theater or movie does not support 2D

    let theater3DMap = _.chain(theaters)
      .mapKeys('id')
      .mapValues(v => !!(v.supports3D === '1'))
      .value();

    let movie3DMap = _.chain(movies)
      .mapKeys('id')
      .mapValues(v => !!(v.is3D === '1'))
      .value();

    let _patchShowtimeHelper = (showtime, theater3D, movie3D) => {
      if (showtime.is3D && (!theater3D || !movie3D)) {
        showtime.is3D = false;
      }
      return showtime;
    };

    schedules = _.chain(schedules)
      .map(schedule => {
        if (schedule && schedule.showtimes) {
          schedule.showtimes = _.map(schedule.showtimes, showtime => {
            if (showtime) {
              let theater3D = !!theater3DMap[showtime.theaterId];
              let movie3D = !!movie3DMap[showtime.movieId];
              if (showtime.generalShowtimes) {
                showtime.generalShowtimes = _.map(showtime.generalShowtimes, v => _patchShowtimeHelper(v, theater3D, movie3D));
              }
              if (showtime.showtimeExceptions) {
                showtime.showtimeExceptions = _.map(showtime.showtimeExceptions, v => _patchShowtimeHelper(v, theater3D, movie3D));
              }
            }
            return showtime;
          });
        }
        return schedule;
      })
      .value();
    return schedules;
  }

}



const publishHelper = new PublishHelper();
export default publishHelper;
export { PublishHelper };
